import { AUTHENTICATOR_COMPONENT } from '@/types/AuthenticatorComponents';

export const onboardingEnvs: string[] = [
  'dev-onboarding.revers.io',
  'demo-onboarding.revers.io',
  'onboarding.revers.io',
];

const useIsOnboardingEnabled = (): boolean => {
  const { hostname } = window.location;

  if (
    import.meta.env.VITE_AUTHENTICATOR_COMPONENT ===
    AUTHENTICATOR_COMPONENT.ON_BOARDING
  ) {
    return true;
  }

  if (onboardingEnvs.includes(hostname)) {
    return true;
  }

  return false;
};

export default useIsOnboardingEnabled;
